import React, { Children } from 'react';
import { connectField, joinName } from 'uniforms';
import AutoField from './AutoField';
import ListDelField from './ListDelField';

var ListItem = function ListItem(props) {
  return React.createElement("div", null, React.createElement("div", {
    style: {
      float: 'right',
      marginBottom: '10px',
      marginLeft: '10px',
      marginRight: '6px',
      width: '20px'
    }
  }, React.createElement(ListDelField, {
    className: "top aligned",
    name: props.name
  })), React.createElement("div", {
    style: {
      marginBottom: '4px',
      overflow: 'hidden'
    }
  }, React.createElement("div", {
    style: {
      borderBottom: '1px solid #DDD',
      height: '20px',
      marginTop: '-8px'
    }
  })), React.createElement("div", {
    style: {
      width: '100%'
    }
  }, props.children ? Children.map(props.children, function (child) {
    return React.cloneElement(child, {
      name: joinName(props.name, child.props.name),
      label: null
    });
  }) : React.createElement(AutoField, Object.assign({}, props))));
};

export default connectField(ListItem, {
  includeInChain: false,
  includeParent: true
});